export default "__VITE_ASSET___Qo_0XV1__"